import { useCallback, useSyncExternalStore } from "react";
import { deleteRulebookDraft, duplicateRulebookDraft, getRulebookDraftsSnapshot, saveRulebookDraft, subscribeRulebookDrafts, } from "./rulebookDraftStore";
const getSnapshot = () => getRulebookDraftsSnapshot();
export default function useRulebookDrafts() {
    const snapshot = useSyncExternalStore(subscribeRulebookDrafts, getSnapshot, getSnapshot);
    const saveDraft = useCallback((definition) => saveRulebookDraft({ definition }), []);
    const removeDraft = useCallback((id) => deleteRulebookDraft({ id }), []);
    const duplicateDraft = useCallback((id) => duplicateRulebookDraft({ id }), []);
    return { drafts: snapshot.drafts, isCorrupt: snapshot.isCorrupt, saveDraft, removeDraft, duplicateDraft };
}
